import { render, staticRenderFns } from "./MarkerItem.vue?vue&type=template&id=809a602e&"
import script from "./MarkerItem.vue?vue&type=script&lang=js&"
export * from "./MarkerItem.vue?vue&type=script&lang=js&"
import style0 from "./MarkerItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports